/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

export const REQUESTED_BANK_PROFILE = 'REQUESTED_BANK_PROFILE';
export const requestedBankProfile = () => ({
  type: REQUESTED_BANK_PROFILE
});

export const RECEIVED_BANK_PROFILE = 'RECEIVED_BANK_PROFILE';
export const receivedBankProfile = (bankProfile) => ({
  type: RECEIVED_BANK_PROFILE,
  bankProfile
});

export const ERROR_BANK_PROFILE = 'ERROR_BANK_PROFILE';
export const errorBankProfile = (error) => ({
  type: ERROR_BANK_PROFILE,
  error
});

export const RECEIVED_CHANGE_UPDATE_BANK = 'RECEIVED_CHANGE_UPDATE_BANK';
export const changeBankToUpdate = (bankAccount) => ({
  type: RECEIVED_CHANGE_UPDATE_BANK,
  bankAccount
});

export const RECEIVED_UPDATE_ADD_ASSOCIATIONS =
  'RECEIVED_UPDATE_ADD_ASSOCIATIONS';
export const updateAddAssociation = (account) => ({
  type: RECEIVED_UPDATE_ADD_ASSOCIATIONS,
  account
});

export const CLEAR_ADD_ASSOCIATIONS = 'CLEAR_ADD_ASSOCIATIONS';
export const clearAddAssociations = () => ({
  type: CLEAR_ADD_ASSOCIATIONS
});

export const SELECT_ALL_ADD_ASSOCIATIONS = 'SELECT_ALL_ADD_ASSOCIATIONS';
export const selectAllAddAssociations = (accounts) => ({
  type: SELECT_ALL_ADD_ASSOCIATIONS,
  accounts
});

export const RECEIVED_UPDATE_DELETE_ASSOCIATIONS =
  'RECEIVED_UPDATE_DELETE_ASSOCIATIONS';
export const updateDeleteAssociation = (account) => ({
  type: RECEIVED_UPDATE_DELETE_ASSOCIATIONS,
  account
});

export const CLEAR_DELETE_ASSOCIATIONS = 'CLEAR_DELETE_ASSOCIATIONS';
export const clearDeleteAssociations = () => ({
  type: CLEAR_DELETE_ASSOCIATIONS
});

export const SELECT_ALL_DELETE_ASSOCIATIONS = 'SELECT_ALL_DELETE_ASSOCIATIONS';
export const selectAllDeleteAssociations = (accounts) => ({
  type: SELECT_ALL_DELETE_ASSOCIATIONS,
  accounts
});

export const RECEIVED_CHANGE_BANK_MODAL_STATE =
  'RECEIVED_CHANGE_BANK_MODAL_STATE';
export const changeBankModalState = (modalState) => ({
  type: RECEIVED_CHANGE_BANK_MODAL_STATE,
  modalState
});

export const REQUESTED_UPDATE_BANK_ASSOCIATIONS =
  'REQUESTED_UPDATE_BANK_ASSOCIATIONS';
export const requestedUpdateBankAssociations = () => ({
  type: REQUESTED_UPDATE_BANK_ASSOCIATIONS
});

export const RECEIVED_UPDATE_BANK_ASSOCIATIONS =
  'RECEIVED_UPDATE_BANK_ASSOCIATIONS';
export const receivedUpdateBankAssociations = () => ({
  type: RECEIVED_UPDATE_BANK_ASSOCIATIONS
});

export const ERROR_UPDATE_BANK_ASSOCIATIONS = 'ERROR_UPDATE_BANK_ASSOCIATIONS';
export const errorUpdateBankAssociations = () => ({
  type: ERROR_UPDATE_BANK_ASSOCIATIONS
});

export const REQUESTED_DELETE_BANK = 'REQUESTED_DELETE_BANK';
export const requestedDeleteBank = () => ({
  type: REQUESTED_DELETE_BANK
});

export const RECEIVED_DELETE_BANK = 'RECEIVED_DELETE_BANK';
export const receivedDeleteBank = () => ({
  type: RECEIVED_DELETE_BANK
});

export const ERROR_DELETE_BANK = 'ERROR_DELETE_BANK';
export const errorDeleteBank = () => ({
  type: ERROR_DELETE_BANK
});

export const REQUESTED_REINITIATE_CHALLENGE_DEPOSITS =
  'REQUESTED_REINITIATE_CHALLENGE_DEPOSITS';
export const requestedReinitiateChallengeDeposits = () => ({
  type: REQUESTED_REINITIATE_CHALLENGE_DEPOSITS
});

export const RECEIVED_REINITIATE_CHALLENGE_DEPOSITS =
  'RECEIVED_REINITIATE_CHALLENGE_DEPOSITS';
export const receivedReinitiateChallengeDeposits = (bankAccount) => ({
  type: RECEIVED_REINITIATE_CHALLENGE_DEPOSITS,
  bankAccount
});

export const ERROR_REINITIATE_CHALLENGE_DEPOSITS =
  'ERROR_REINITIATE_CHALLENGE_DEPOSITS';
export const errorReinitiateChallengeDeposits = (bankAccount) => ({
  type: ERROR_REINITIATE_CHALLENGE_DEPOSITS,
  bankAccount
});

export const REQUESTED_CHALLENGE_DEPOSIT_VERIFICATION =
  'REQUESTED_CHALLENGE_DEPOSIT_VERIFICATION';
export const requestedChallengeDepositVerification = () => ({
  type: REQUESTED_CHALLENGE_DEPOSIT_VERIFICATION
});

export const RECEIVED_CHALLENGE_DEPOSIT_VERIFICATION =
  'RECEIVED_CHALLENGE_DEPOSIT_VERIFICATION';
export const receivedChallengeDepositVerification = (bankAccount) => ({
  type: RECEIVED_CHALLENGE_DEPOSIT_VERIFICATION,
  bankAccount
});

export const ERROR_CHALLENGE_DEPOSIT_VERIFICATION =
  'ERROR_CHALLENGE_DEPOSIT_VERIFICATION';
export const errorChallengeDepositVerification = (bankAccount) => ({
  type: ERROR_CHALLENGE_DEPOSIT_VERIFICATION,
  bankAccount
});

export const CLEAR_BANKS_IN_ERROR_CHALLENGE_DEPOSIT =
  'CLEAR_BANKS_IN_ERROR_CHALLENGE_DEPOSIT';
export const clearBanksInErrorChallengeDeposit = () => ({
  type: CLEAR_BANKS_IN_ERROR_CHALLENGE_DEPOSIT
});

export const REQUESTED_BANK_VERIFICATIONS = 'REQUESTED_BANK_VERIFICATIONS';
export const requestedBankVerifications = () => ({
  type: REQUESTED_BANK_VERIFICATIONS
});

export const RECEIVED_BANK_VERIFICATIONS = 'RECEIVED_BANK_VERIFICATIONS';
export const receivedBankVerifications = (verifications) => ({
  type: RECEIVED_BANK_VERIFICATIONS,
  verifications
});

export const ERROR_BANK_VERIFICATIONS = 'ERROR_BANK_VERIFICATIONS';
export const errorBankVerifications = () => ({
  type: ERROR_BANK_VERIFICATIONS
});

export const REQUESTED_ELIGIBLE_AGREEMENTS_FOR_BANK =
  'REQUESTED_ELIGIBLE_AGREEMENTS_FOR_BANK';
export const requestedEligibleAgreementsForBank = () => ({
  type: REQUESTED_ELIGIBLE_AGREEMENTS_FOR_BANK
});

export const RECEIVED_ELIGIBLE_AGREEMENTS_FOR_BANK =
  'RECEIVED_ELIGIBLE_AGREEMENTS_FOR_BANK';
export const receivedEligibleAgreementsForBank = (accounts) => ({
  type: RECEIVED_ELIGIBLE_AGREEMENTS_FOR_BANK,
  accounts
});

export const ERROR_ELIGIBLE_AGREEMENTS_FOR_BANK =
  'ERROR_ELIGIBLE_AGREEMENTS_FOR_BANK';
export const errorEligibleAgreementsForBank = () => ({
  type: ERROR_ELIGIBLE_AGREEMENTS_FOR_BANK
});
